import * as React               from 'react';

import { Typography           } from 'src/components/common/typography';

import { Wrapper,
         Container,
         InvoiceListContainer,
         InvoiceItem,
         InvoiceItemRow,
         InvoiceListVariants,
         invoicelist_variants } from 'src/components/features/qmmsg/detail/invoice-list/ui';

import * as types               from 'src/services/api/types';
import Util                     from 'src/services/util';



type Props = {
  variant: InvoiceListVariants;
  header: string;
  invoices: types.qmmsg.QMMsgAccountInvoice[];
}
export const InvoiceList: React.FC<Props> = ({
  variant,
  header,
  invoices,
}) => {
  const lookAndFeel = invoicelist_variants.get(variant)!;

  return (
    <Wrapper lookAndFeel = { lookAndFeel }>
      <Container lookAndFeel = { lookAndFeel }>
        <Typography variant = { lookAndFeel.headerTypographyVariant }>{ header }</Typography>
          <InvoiceListContainer lookAndFeel = { lookAndFeel }>
            {invoices.map((invoice) => (
              <InvoiceItem lookAndFeel = { lookAndFeel }>
                <InvoiceItemRow lookAndFeel = { lookAndFeel }>
                  <Typography variant = { lookAndFeel.invoiceRowKeyTypographyVariant }>Поставка</Typography>
                  <Typography variant = { lookAndFeel.invoiceRowValueTypographyVariant }>{ invoice.invoice }</Typography>
                </InvoiceItemRow>
                <InvoiceItemRow lookAndFeel = { lookAndFeel }>
                  <Typography variant = { lookAndFeel.invoiceRowKeyTypographyVariant }>Номер документа</Typography>
                  <Typography variant = { lookAndFeel.invoiceRowValueTypographyVariant }>{ invoice.accountDocumentNum ?? '-' }</Typography>
                </InvoiceItemRow>
                <InvoiceItemRow lookAndFeel = { lookAndFeel }>
                  <Typography variant = { lookAndFeel.invoiceRowKeyTypographyVariant }>Дата</Typography>
                  <Typography variant = { lookAndFeel.invoiceRowValueTypographyVariant }>
                    { invoice.timestampInvoice !== null ?
                        Util.dateFormat(new Date(invoice.timestampInvoice), 'DD.MM.YYYY')
                        :
                        '-'
                    }
                  </Typography>
                </InvoiceItemRow>
                <InvoiceItemRow lookAndFeel = { lookAndFeel }>
                  <Typography variant = { lookAndFeel.invoiceRowKeyTypographyVariant }>Сумма (с ндс)</Typography>
                  <Typography variant = { lookAndFeel.invoiceRowValueTypographyVariant }>{ invoice.netAmount }</Typography>
                </InvoiceItemRow>
                <InvoiceItemRow lookAndFeel = { lookAndFeel }>
                  <Typography variant = { lookAndFeel.invoiceRowKeyTypographyVariant }>Валюта</Typography>
                  <Typography variant = { lookAndFeel.invoiceRowValueTypographyVariant }>{ invoice.unit }</Typography>
                </InvoiceItemRow>
              </InvoiceItem>
            ))}
          </InvoiceListContainer>
      </Container>
    </Wrapper>
  );
};
